import { Component, DestroyRef, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatAccordion } from '@angular/material/expansion';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-edit-stall',
  templateUrl: './edit-stall.component.html',
  styleUrls: ['./edit-stall.component.scss']
})
export class EditStallComponent {
  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  @ViewChild(MatAccordion) accordion!: any;
  @Input() so_id: any;

  // so_id: any;
  StallForm!: FormGroup;

  result: any;
  private destoryRef = inject(DestroyRef);
  owner_data: any;
  event_id: any;
  stall_id: any;
  selectedStall_id: any;

  imagefileURL!: any | ArrayBuffer;
  imagePath: any;
  isOld1: boolean = false;
  image_name: any;

  options: { stall_num: string; id: any }[] = [];
  filteredOptions: { stall_num: string; id: any }[] = [];

  constructor(
    private fb: FormBuilder,
    private service: ServicesService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Get so_id from URL
    if (!this.so_id) {
      this.so_id = this.route.snapshot.paramMap.get('so_id');
    }
    console.log(this.so_id);

    // Initialize Form
    this.StallForm = this.fb.group({
      so_id: this.so_id,
      stall_num: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/)]),
      stall_id: new FormControl(''),
      image_name: new FormControl(''),
      owner_name: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/)]),
      owner_number: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/)]),
      company_name: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/)]),
      address: new FormControl('', [Validators.maxLength(250)]),
      website: new FormControl('', [Validators.maxLength(250)]),
      youtube: new FormControl('', [Validators.maxLength(250)]),
      facebook: new FormControl('', [Validators.maxLength(250)]),
      instagram: new FormControl('', [Validators.maxLength(250)]),
      notes: new FormControl('')
    });

    // Fetch initial data
    this.get_stall_owner_by_id(this.so_id);
    this.get_available_stall();
  }

  /** Filter for autocomplete */
  filter() {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this.filteredOptions = this.options.filter(option =>
      option.stall_num.toLowerCase().includes(filterValue)
    );
  }

  /** Fetch available stalls */
  get_available_stall() {
    this.service.get_available_stall().pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
      next: (data: any) => {
        this.options = data.data.map((item: { stall_num: string; id: number }) => ({
          stall_num: item.stall_num,
          id: item.id
        }));
      },
      error: () => {
        this.toastr.error('Failed to load stall list');
      }
    });
  }

  /** Load stall owner by so_id */
  get_stall_owner_by_id(so_id: any) {
    this.service.get_stall_owner_by_id(so_id).subscribe({
      next: (data: any) => {
        this.owner_data = data.data;
        const owner = this.owner_data[0];

        this.event_id = owner.event_id;

        this.StallForm.patchValue({
          so_id: owner.so_id,
          stall_id: owner.stall_id,
          stall_num: owner.stall_num,
          owner_name: owner.owner_name,
          owner_number: owner.owner_number,
          company_name: owner.company_name,
          address: owner.address,
          website: owner.website,
          youtube: owner.youtube,
          facebook: owner.facebook,
          instagram: owner.instagram,
          notes: owner.notes,
          image_name: owner.image_name
        });

        this.image_name = owner.image_name;
        this.isOld1 = true;
      },
      error: () => {
        this.toastr.error('Failed to load stall owner details');
      }
    });
  }

  /** Image Preview and Upload */
  previewpimage(files: any) {
    if (files.length === 0) return;

    const mimeType = files[0].type;
    if (!mimeType.match(/image\/*/)) {
      this.toastr.error('Only images are supported.');
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      this.imagefileURL = reader.result;;

      this.service.uploadimage(this.imagefileURL, this.event_id + "/stall").subscribe((data: any) => {
        this.isOld1 = false;
        this.imagePath = data['image_name'];
        console.log(this.imagePath);

        // this.StallForm.patchValue({ image_name: this.imagePath });
      });
    };
  }


  /** Submit Form */
  onFormSubmit() {
    if (!this.StallForm.valid) {
      this.toastr.error('Please fill in required fields');
      return;
    }

    const ExistedImage = this.isOld1 ? this.image_name : this.imagePath;

    this.StallForm.patchValue({
      stall_id: this.selectedStall_id ? this.selectedStall_id : this.StallForm.value.stall_id,
      image_name: ExistedImage
    });

    if (this.so_id) {
      this.service.edit_stall_owner(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
        next: () => {
          this.toastr.success('Stall Owner Updated Successfully');
          // this.router.navigate(['/stall-list']); // redirect after success
        },
        error: (err: any) => {
          console.error(err);
          this.toastr.error('Failed to update stall owner');
        }
      });
    } else {
      this.service.add_stall_owner(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
        next: () => {
          this.toastr.success('Stall Owner Added Successfully');
          // this.router.navigate(['/stall-list']); // redirect after success
        },
        error: (err: any) => {
          console.error(err);
          this.toastr.error('Failed to add stall owner');
        }
      });
    }
  }
}
